import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';
import ListTable from '../../../../common/components/ListTable';
import Loading from '../../../../common/components/Loading';
import PopUp from '../../../../common/components/PopUp';
import QueueMigrate from '../QueueMigrate/QueueMigrate';
import QueueNew from '../QueueNew';
import { HEADERS } from './constants/headers';
import {
	Flex,
	QueueTableWrapper,
	ShowArrow,
	TableTitle,
	Wrapper,
} from './styles';
import useQueueList from './useQueueList';
import Icon from '@/common/components/Icon';
import { AuthContext } from '@/common/contexts/authContext';
import { useContext } from 'react';

const QueueList = () => {
	const { authUser } = useContext(AuthContext);
	const hook = useQueueList();
	return (
		<>
			{hook.isLoading && <Loading />}
			<Wrapper>
				<Flex>
					<ActionButton
						onClick={() => {
							hook.setShowNew(true);
							hook.setSelectedToDuplicate(null);
						}}
						defaultText='Create queue'
					/>
					{authUser.access.includes('QUEUE_MIGRATE') && (
						<ActionButton
							onClick={() => hook.setShowMigrateModal(true)}
							defaultText='Migrate queue'
							color={Colors.red}
						/>
					)}
				</Flex>
				<TableTitle onClick={() => hook.setShowActive((prev) => !prev)}>
					Active queues{' '}
					<Icon size={25} rotate={!hook.showActive} name='arrow-down' />
				</TableTitle>
				<QueueTableWrapper show={hook.showActive}>
					<ListTable
						column={HEADERS}
						row={hook.activeRaws}
						entityName={'queue'}
						actions={{ onDuplicate: (_id) => hook.handleDuplicateClick(_id) }}
					/>
				</QueueTableWrapper>
				<TableTitle onClick={() => hook.setShowActive((prev) => !prev)}>
					Not active quesues{' '}
					<Icon size={25} rotate={hook.showActive} name='arrow-down' />
				</TableTitle>
				<QueueTableWrapper show={!hook.showActive}>
					<ListTable
						column={HEADERS}
						row={hook.inActiveRaws}
						entityName={'queue'}
						actions={{ onDuplicate: (_id) => hook.handleDuplicateClick(_id) }}
					/>
				</QueueTableWrapper>
			</Wrapper>
			{hook.showNew && (
				<PopUp setShow={hook.setShowNew} top={40}>
					<QueueNew
						close={() => {
							hook.setShowNew(false);
							hook.setSelectedToDuplicate(null);
						}}
						selectedToDuplicate={hook.selectedToDuplicate}
					/>
				</PopUp>
			)}
			{hook.showMigrateModal && (
				<PopUp setShow={hook.setShowMigrateModal} top={40}>
					<QueueMigrate close={() => hook.setShowMigrateModal(false)} />
				</PopUp>
			)}
		</>
	);
};

export default QueueList;
